import React, {memo} from "react";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-left: auto;
  position: relative;
`;

const StyledRemoveButtonControlWrapperDiv = styled.div`
  position: absolute;
  top: -36px;
  right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledAudioControlContainerDiv = styled.div`
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const Audio = ({controls, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    const audioUUID = controls[0].key.split("_")[0];
    const removeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getAudioRemoveButtonKey(audioUUID)));
    const audioFileControl = controls.find(control => control.key.includes(SequenceComponentHelper.getAudioFileKey(audioUUID)));

    return (
        <>

            {/** NESTED NODE - IMAGE */}
            <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                {/** REMOVE BTN */}
                {!isNodeCollapsed &&
                    <StyledRemoveButtonContainerDiv>
                        <StyledRemoveButtonControlWrapperDiv>
                            <Control key={removeControl.key} control={removeControl} innerRef={bindControl}/>
                        </StyledRemoveButtonControlWrapperDiv>
                    </StyledRemoveButtonContainerDiv>
                }

                {/** AUDIO CONTROL */}
                <StyledAudioControlContainerDiv>
                    <Control key={audioFileControl.key} control={audioFileControl} innerRef={bindControl}/>
                </StyledAudioControlContainerDiv>
            </StyledNestedNodeDiv>
        </>
    );
}

export default memo(Audio);